// import React from "react";
// import skills from "../../data/skills.json";

// function Skills() {
//   return (
//     <div className="container skills">
//       <h1>Skills</h1>
//       {skills.map((data, index) => (
//         <div className="items" key={index}>
//           <div className="item">
//             <img
//               src={require(`../../asset/skills/${data.imageSrc}`)}
//               alt={data.title}
//             />
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default Skills;


// import React from 'react'
// import skills from '../../data/skills.json'

// function Skills() {
//   return (
//     <>
//     <div className="container skills">
//       <h1>Skills</h1>
//       {skills.map((data)=>(<>
//       <div className="items">
//         <div className="item">
//           <img src={`../asset/skills/${data.imageSrc}`} alt="" />
//         </div>
//       </div>
//       </>))}
//     </div>
//     </>
//   )
// }

// export default Skills





















// import React from 'react';
// import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaGitAlt, FaDocker, FaCubes } from 'react-icons/fa';
// import { SiTypescript, SiRedux, SiTailwindcss, SiMongodb, SiFigma } from 'react-icons/si';
// import './skills.css'; // Import CSS

// const Languages = () => {
//   const skills = [
//     { icon: <FaHtml5 size={40} />, name: 'HTML' },
//     { icon: <FaCss3Alt size={40} />, name: 'CSS' },
//     { icon: <FaJs size={40} />, name: 'JavaScript' },
//     { icon: <SiTypescript size={40} />, name: 'TypeScript' },
//     { icon: <FaReact size={40} />, name: 'React' },
//     { icon: <SiRedux size={40} />, name: 'Redux' },
//     { icon: <SiTailwindcss size={40} />, name: 'Tailwind CSS' },
//     { icon: <SiMongodb size={40} />, name: 'MongoDB' },
//     { icon: <FaCubes size={40} />, name: 'Three.js' }, // Placeholder icon for Three.js
//     { icon: <FaGitAlt size={40} />, name: 'Git' },
//     { icon: <SiFigma size={40} />, name: 'Figma' },
//     { icon: <FaDocker size={40} />, name: 'Docker' },
//   ];

//   return (
//     <div className="languages-container">
//       <h2 className="languages-title">Skills</h2>
//       <div className="languages-grid">
//         {skills.map((skill, index) => (
//           <div className="language-item" key={index}>
//             <div className="language-icon">{skill.icon}</div>
//             <p className="language-name">{skill.name}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Languages;
import React, { useEffect } from "react";
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaGitAlt, FaDocker } from "react-icons/fa";
import { SiTailwindcss, SiMongodb, SiFigma } from "react-icons/si";
import AOS from "aos"; // Import AOS
import "aos/dist/aos.css"; // Import AOS CSS
import "./skills.css";

const Skills = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with animation duration
  }, []);

  const skills = [
    { icon: <FaHtml5 size={40} />, name: "HTML" },
    { icon: <FaCss3Alt size={40} />, name: "CSS" },
    { icon: <FaJs size={40} />, name: "JavaScript" },
    { icon: <FaReact size={40} />, name: "React" },
    { icon: <SiTailwindcss size={40} />, name: "Tailwind CSS" },
    { icon: <SiMongodb size={40} />, name: "MongoDB" },
    { icon: <FaGitAlt size={40} />, name: "Git" },
    { icon: <SiFigma size={40} />, name: "Figma" },
    { icon: <FaDocker size={40} />, name: "Docker" },
  ];


  return (
    <div className="languages-container">
      <h2 className="languages-title">Skills</h2>
      <div className="languages-grid">
        {skills.map((skill, index) => (
          <div
            className="language-item"
            key={index}
            data-aos="flip-right" // AOS flip-right animation
            data-aos-duration="1000" // Animation duration
          >
            <div className="language-icon">{skill.icon}</div>
            <p className="language-name">{skill.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;